import { Link } from 'react-router-dom';
import GlobalSearch from './GlobalSearch';
import NotificationsDropdown from './NotificationsDropdown';
import QuickCreateMenu from './QuickCreateMenu';
import Dropdown from '@/components/base/Dropdown';
import { useAuth } from '@/context/AuthContext';

interface TopbarProps {
  onMenuClick: () => void;
}

export default function Topbar({ onMenuClick }: TopbarProps) {
  const { user, signOut } = useAuth();
  const email = user?.email ?? '';
  const displayName = email ? email.split('@')[0] : 'Yönetici';
  const initial = email ? email[0].toUpperCase() : '3D';

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center gap-3 border-b border-background-200 bg-background-50/95 px-4 backdrop-blur md:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-600 transition-colors hover:bg-background-100 lg:hidden"
      >
        <i className="ri-menu-line text-xl" />
      </button>

      <GlobalSearch />

      <div className="ml-auto flex shrink-0 items-center gap-2">
        <NotificationsDropdown />
        <QuickCreateMenu />
        <Dropdown
          align="right"
          triggerClassName="flex items-center gap-2 rounded-md px-1.5 py-1 transition-colors hover:bg-background-100"
          trigger={
            <>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-white">
                {initial}
              </span>
              <span className="hidden text-left lg:block">
                <span className="block text-sm font-semibold leading-tight text-foreground-900">{displayName}</span>
                <span className="block text-[11px] leading-tight text-foreground-500">Yönetici</span>
              </span>
            </>
          }
        >
          {(close) => (
            <div className="py-1">
              <div className="border-b border-background-100 px-3 py-2">
                <p className="text-sm font-semibold text-foreground-900">{displayName}</p>
                <p className="truncate text-xs text-foreground-500">{email}</p>
              </div>
              <Link
                to="/settings"
                onClick={close}
                className="flex w-full items-center gap-2.5 rounded-md px-3 py-2 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                  <i className="ri-settings-4-line" />
                </span>
                <span className="whitespace-nowrap">Ayarlar</span>
              </Link>
              <button
                type="button"
                onClick={() => {
                  close();
                  signOut();
                }}
                className="flex w-full cursor-pointer items-center gap-2.5 rounded-md px-3 py-2 text-left text-sm text-accent-700 transition-colors hover:bg-background-100"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-background-100 text-accent-700">
                  <i className="ri-logout-box-r-line" />
                </span>
                <span className="whitespace-nowrap">Çıkış Yap</span>
              </button>
            </div>
          )}
        </Dropdown>
      </div>
    </header>
  );
}